var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"base-list"},[_vm._l((_vm.items),function(item,index){return [_c('BaseListItem',{key:'baseListItem_' + index,attrs:{"item":item,"uppercase":_vm.uppercase}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }